import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IAppInvitation } from '../types/app-invitation.types';

interface AppInvitationState extends BaseDataReducerInitialState<IAppInvitation> {
  perPage: number;
  isModalOpen: boolean;
}

const { initialState, AC, reducer } = basedDataReducer<IAppInvitation, AppInvitationState>('app-invitation');

const appInvitationState: AppInvitationState = {
  ...initialState,
  perPage: 10,
  isModalOpen: false,
};

export const appInvitation = createSlice({
  name: 'appInvitation',
  initialState: appInvitationState,
  reducers: {
    setIsAppInvitationModalOpen(state, action: PayloadAction<boolean>) {
      state.isModalOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as AppInvitationState, action);
    });
  },
});
export const AppInvitationAC = AC;
export const setAppInvitationCurrentPage = AC.setCurrentPage;

export const { setIsAppInvitationModalOpen } = appInvitation.actions;
